<template>
  <div class="homePage">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <!-- pc版 -->
    <div v-loading="loading" class="pc">
      <!-- 医院概况 -->
      <div class="home" style="background: #f9f7f4">
        <div class="big-title">
          <div class="big-name">医院概况</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">OVERVIEW</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div class="flex-center" style="margin-top: 40px">
          <div style="width: 44%; margin-right: 40px">
            <img :src="`${info.survey_file}`" alt="" style="width: 100%" />
          </div>
          <div style="flex: 1" class="text-bar">
            <div class="text-name">{{ info.survey_title }}</div>
            <div v-html="info.survey_desc"></div>
            <el-button class="getMore" size="big" @click="go('about')"
              >了解更多</el-button
            >
          </div>
        </div>
      </div>
      <!-- 医院资讯 -->
      <div
        class="manor showList"
        id="manor"
        v-show="show"
        :style="`background-image: url(${info.news_images});animation-duration: 1.2s;`"
      >
        <div>
          <div class="big-title">
            <div class="big-name">医院资讯</div>
            <div class="big-eng" style="margin-top: 10px">
              <span class="line" style="border-top: 1px solid #fff"></span>
              <span class="txt" style="color: #fff">MANOR</span>
              <span class="line" style="border-top: 1px solid #fff"></span>
            </div>
          </div>
          <div
            class="ta-center"
            style="
              color: #fff;
              font-size: 16px;
              letter-spacing: 2px;
              margin-top: 40px;
            "
          >
            <div v-html="info.news_desc"></div>
          </div>
          <div style="text-align: center">
            <el-button
              style="margin-top: 160px"
              class="getMore"
              @click="go('news')"
              >了解更多</el-button
            >
          </div>
        </div>
      </div>
      <!-- 特色医疗 -->
      <div class="home" style="background: #f9f7f4">
        <div class="big-title">
          <div class="big-name">特色医疗</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">FEATURED TREATMENT</span>
            <span class="line-right"></span>
          </div>
          <div style="margin-top: 20px; font-weight: 600">
            推崇标本兼治,签约临床治愈
          </div>
        </div>
        <div class="flex-center" style="margin-top: 60px">
          <template v-for="(item, index) of tsList">
            <div
              style="flex: 1; margin-right: 28px; text-align: center"
              v-if="item.isContent === 1 && item.images_icon !== ''"
              :key="index"
            >
              <img
                :src="`${item.images_icon}`"
                alt=""
                class="tsNAame"
                style="
                  width: 80%;
                  background: #fff;
                  padding: 20px;
                  border-radius: 100%;
                  max-height: 180px;
                "
              />
              <div style="margin-top: 10px">{{ item.main_title }}</div>
            </div>
          </template>
        </div>
        <div style="text-align: center">
          <el-button
            style="margin-top: 80px"
            class="getMore"
            @click="go('characteristic')"
            >了解更多</el-button
          >
        </div>
      </div>
    </div>
    <!-- 手机版 -->
    <div class="mobile">
      <!-- 特色医疗板块 -->
      <div>
        <div class="mobileTitle" style="padding: 0.1rem 0; background: #fff4e4">
          <img
            src="../assets/mobile/left.png"
            alt=""
            style="margin-right: 0.2rem; width: 0.16rem"
          />
          特色医疗
          <img
            src="../assets/mobile/right.png"
            alt=""
            style="margin-left: 0.2rem; width: 0.16rem"
          />
        </div>
        <!-- 特色医疗动态轮播 -->
        <div class="swipe-bg" v-loading="loading">
          <div
            class="switch-Tab"
            @touchstart="swipeStart($event)"
            @touchend="swipeEnd($event)"
            @touchmove="swipeMove($event)"
            style="height: 3rem"
          >
            <div
              v-for="(item, index) of tsList1"
              :key="index"
              class="swipeClass"
              @click="gocharacteristic(item.id, index,item.isContent)"
            >
              <div class="jzBg">
                <div
                  v-if="item.main_title.indexOf(`Ig`) !== -1"
                  :style="`${
                    index === 0 ? 'font-size:0.19rem;line-height: 0.27rem;' : ''
                  }`"
                  v-html="
                    item.main_title.replace(
                      'IgA',
                      `<span style='font-size:0.17rem;'>IgA</span><br>`
                    )
                  "
                ></div>
                <div v-else>{{ item.main_title }}</div>
              </div>
            </div>
          </div>
          <!-- <swipe></swipe> -->
        </div>
      </div>
      <!-- 新闻/视频资讯板块 -->
      <div
        style="border-top: 5px solid #e5e5e5; padding: 0 10px; min-height: 3rem"
      >
        <div
          class="list-tit flex-center"
          style="margin-bottom: 20px; margin: 10px 0"
        >
          <div style="font-size: 0.16rem; flex: 1">
            <span style="font-weight: blod; color: #763a27; padding: 0 0.1rem"
              >医院资讯</span
            >
            <span class="list-eng">Hospital Information</span>
          </div>
          <div style="font-size: 0.1rem; color: #4f4f4f" @click="go(`news`)">
            更多>
          </div>
        </div>
        <div v-loading="loading1">
          <div class="flex-center" style="margin-top: 0.16rem">
            <div
              :class="newType === 1 ? 'mob-select' : 'mob-noSelect'"
              style="margin-right: 0.16rem"
              @click="getNews(1, '1')"
            >
              新闻资讯
            </div>
            <div
              :class="newType === 2 ? 'mob-select' : 'mob-noSelect'"
              @click="getNews(2, '2')"
            >
              视频资讯
            </div>
          </div>
          <div class="flex-center">
            <div style="flex: 1; margin-right: 0.16rem">
              <div
                class="triangle-down"
                :style="
                  newType === 2
                    ? 'border-top: 0.1rem solid #fff;margin: 0 auto;'
                    : ''
                "
              ></div>
            </div>
            <div style="flex: 1">
              <div
                class="triangle-down"
                :style="
                  newType === 1
                    ? 'border-top: 0.1rem solid #fff;margin: 0 auto;'
                    : ''
                "
              ></div>
            </div>
          </div>
          <div class="newList switch-Tab">
            <van-tabs v-model="newType" @change="getNews" swipeable animated>
              <van-tab title="新闻资讯" :name="1">
                <div
                  v-for="(item, index) of newList1"
                  :key="index"
                  class=""
                  :style="index === 0 ? `margin-top:0.1rem` : ``"
                  @click="goNewsDetail(item.id)"
                >
                  <div
                    v-if="index === 0"
                    class="flex-center"
                    style="height: 1.11rem"
                  >
                    <div
                      style="
                        margin-right: 0.1rem;
                        width: 1.2rem;
                        height: 0.95rem;
                        position: relative;
                      "
                    >
                      <img
                        :src="item.images"
                        alt=""
                        style="width: 100%; height: 0.95rem"
                      />
                    </div>
                    <div style="width: calc(100% - 1.3rem)">
                      <div class="f15 ellipsis newstitle" style="">
                        {{ item.title || "" }}
                      </div>
                      <div class="f14 ellipsis" style="min-height: 0.5rem">
                        {{ item.abstract }}
                      </div>
                      <div
                        class="f14"
                        style="margin-top: 0.1rem; color: #763a27"
                      >
                        【详情】
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div v-else-if="index < 5">
                    <div
                      class="f14 ellipsis newstitle flex-center"
                      style="
                        font-weight: 500;
                        border-bottom: 1px solid #e5e5e5;
                        margin-bottom: 0;
                        height: 0.32rem;
                        line-height: 0.32rem;
                      "
                    >
                      <img
                        src="../assets/mobile/4.png"
                        alt=""
                        style="width: 0.1rem"
                      />
                      {{ item.title || "" }}
                    </div>
                  </div>
                </div>
              </van-tab>
              <van-tab title="视频资讯" :name="2">
                <div
                  v-for="(item, index) of newList2"
                  :key="index"
                  class=""
                  :style="index === 0 ? `margin-top:0.1rem` : ``"
                  @click="goNewsDetail(item.id)"
                >
                  <div
                    v-if="index === 0"
                    class="flex-center"
                    style="height: 1.11rem"
                  >
                    <div
                      style="
                        margin-right: 0.1rem;
                        width: 1.2rem;
                        height: 0.95rem;
                        position: relative;
                      "
                    >
                      <img
                        :src="item.images"
                        alt=""
                        style="width: 100%; height: 0.95rem"
                      />
                    </div>
                    <div style="width: calc(100% - 1.3rem)">
                      <div class="f15 ellipsis newstitle" style="">
                        {{ item.title || "" }}
                      </div>
                      <div class="f14 ellipsis" style="min-height: 0.5rem">
                        {{ item.abstract }}
                      </div>
                      <div
                        class="f14"
                        style="margin-top: 0.1rem; color: #763a27"
                      >
                        【详情】
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div v-else-if="index < 5">
                    <div
                      class="f14 ellipsis newstitle flex-center"
                      style="
                        font-weight: 500;
                        border-bottom: 1px solid #e5e5e5;
                        margin-bottom: 0;
                        height: 0.32rem;
                        line-height: 0.32rem;
                      "
                    >
                      <img
                        src="../assets/mobile/4.png"
                        alt=""
                        style="width: 0.1rem"
                      />
                      {{ item.title || "" }}
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <div class="moreBtn" @click="go(`news`)">
          点击了解更多医院资讯
          <img
            src="../assets/mobile/pointer1.png"
            alt=""
            style="width: 0.1rem"
          />
        </div>
      </div>
      <!-- 病历简介板块 -->
      <div
        style="border-top: 5px solid #e5e5e5; padding: 0 10px; min-height: 3rem"
        v-loading="loading2"
      >
        <div
          class="list-tit flex-center"
          style="margin-bottom: 20px; margin: 10px 0"
        >
          <div style="font-size: 0.16rem; flex: 1">
            <span style="font-weight: blod; color: #763a27; padding: 0 0.1rem"
              >病历简介</span
            >
            <span class="list-eng">Brief Medical Records</span>
          </div>
          <div
            style="font-size: 0.1rem; color: #4f4f4f"
            @click="go(`medicalRecord`)"
          >
            更多>
          </div>
        </div>
        <div style="margin-top: 10px">
          <div
            class="f14 ellipsis newstitle"
            style="
              font-weight: 500;
              border-bottom: 1px solid #e5e5e5;
              margin-bottom: 0;
              height: 0.32rem;
              line-height: 0.32rem;
            "
            v-for="(item, index) of tsDetail"
            :key="index"
            @click="gomedical(item)"
          >
            <img src="../assets/mobile/4.png" alt="" style="width: 0.1rem" />
            {{ item.title || "" }}
          </div>
        </div>
        <div class="moreBtn" @click="go(`medicalRecord`)">
          点击了解更多病历简介
          <img
            src="../assets/mobile/pointer1.png"
            alt=""
            style="width: 0.1rem"
          />
        </div>
      </div>
      <!-- 医院环境/设备/荣誉板块 -->
      <div
        style="
          border-top: 5px solid #e5e5e5;
          padding: 0 10px 10px;
          min-height: 2rem;
        "
        class="switch-Tab"
      >
        <van-tabs
          v-model="active1"
          swipeable
          animated
          color="#763a27"
          title-active-color="#763a27"
          :swipe-threshold="3"
          style="border-bottom: 1px solid #e5e5e5"
        >
          <van-tab title="医院环境" title-class="vanTabClass">
            <ul class="active1-img" style="">
              <div
                v-for="(item, index) of photo1"
                :key="index"
                v-if="index < 4"
              >
                <img :src="item" alt="" />
              </div>
            </ul>
          </van-tab>
          <van-tab title="医院设备" title-class="vanTabClass">
            <ul class="active1-img" style="">
              <div
                v-for="(item, index) of photo2"
                :key="index"
                v-if="index < 4"
              >
                <img :src="item" alt="" />
              </div>
            </ul>
          </van-tab>
          <van-tab title="医院荣誉" title-class="vanTabClass">
            <ul class="active1-img" style="">
              <div>
                <img src="../assets/pai.png" alt="" />
              </div>
              <div>
                <img src="../assets/pai2.png" alt="" />
              </div>
              <div>
                <img src="../assets/pai3.png" alt="" />
              </div>
              <div>
                <img src="../assets/pai4.png" alt="" />
              </div>
            </ul>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 功能列表（宫格）板块 -->
      <van-grid
        :column-num="4"
        :border="false"
        style="border-top: 5px solid #e5e5e5"
      >
        <van-grid-item icon="photo-o" @click="go(`environment`)">
          <img src="../assets/mobile/icon1.png" class="gongImg" />
          <div class="gongText">医院环境</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="goGuide(1)">
          <img src="../assets/mobile/icon2.png" class="gongImg" />
          <div class="gongText">防疫指南</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="goGuide(2)">
          <img src="../assets/mobile/icon3.png" class="gongImg" />
          <div class="gongText">就医流程</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="goyuyue">
          <img src="../assets/mobile/icon4.png" class="gongImg" />
          <div class="gongText">快速挂号</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="goGuide(4)">
          <img src="../assets/mobile/icon5.png" class="gongImg" />
          <div class="gongText">电话预约</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="go(`contact`)">
          <img src="../assets/mobile/icon6.png" class="gongImg" />
          <div class="gongText">电子地图</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="gocontact(3)">
          <img src="../assets/mobile/icon7.png" class="gongImg" />
          <div class="gongText">在线留言</div>
        </van-grid-item>
        <van-grid-item icon="photo-o" @click="gocontact(4)">
          <img src="../assets/mobile/icon8.png" class="gongImg" />
          <div class="gongText">调查问卷</div>
        </van-grid-item>
      </van-grid>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import {
  getmenudetail,
  medicallist,
  newslist,
  videolist,
  synopsislBymedicalId,
  synopsistop6,
} from "@/api/common";
export default {
  name: "HelloWorld",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "home", //定位当前页面菜单
      active1: 0, //医院环境/设备/荣誉标签 选中值
      info: { carousel: "", Mcarousel: "" }, //轮播图
      tsList: [], //pc端特色医疗动态
      tsList1: [], //手机端特色医疗动态
      tsDetail: [], //病历简介列表
      show: false, //显示医院资讯
      loading: true, // pc端加载loading
      loading1: true, // 新闻动态加载loading
      loading2: true, // 病历简介加载loading
      loading3: true, // 视频动态加载loading
      newList1: [], //新闻动态列表
      newList2: [], //视频动态列表
      newType: 1, //医院资讯选项
      form: {
        page: 1,
        pageSize: 5,
      }, //医院资讯列表分页
      photo1: [], //环境图片
      photo2: [], //设备图片
      nowSwipe: [], //当前特色医疗轮播位置
      start: 0, //轮播起始位置
      timer: null, //定时器
    };
  },
  mounted() {
    
    this.getwg("home");
    getmenudetail({ id: 1 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
      this.postMessage(
        "东莞黄家圣幸中医医院",
        "黄家圣幸肾病专科医院是黄家圣幸集团下属肾病综合专科医院，秉承“一切为了人类健康”的使命，突出中医特色，发挥专科特长，坚持“一切以治愈为目的”的服务宗旨，已建成肾病专科、免疫性疾病专科。运用中医特效疗法，在IgA肾病、肾炎、慢性肾病领域疗效显著，在类风湿性关节炎及强直性脊柱炎领域建立诊疗优势。黄家圣幸肾病专科医院，将肩负着“推进健康中国建设，促进中医药传承与发展”的历史使命，努力创建国内一流、国际知名的现代化中医院",
        "http://www.sensin.com.cn/",
        "http://sensin-his-website.oss-cn-beijing.aliyuncs.com/live/dcfa436bd8fbf0c0393b7c8ae645baa3e47fdbfe.jpg"
      );
    });
    getmenudetail({ id: 4 }).then((res) => {
      this.photo1 = res.data.environment_images;
      this.photo2 = res.data.equipment_images;
    });
    medicallist().then((res) => {
      this.tsList = [...res.data];
      this.tsList1 = [...res.data];
      this.loading = false;
      this.getPdf();
      this.$nextTick(() => {
        this.setSwipe();
      });
    });
    this.getNews(1);
    window.addEventListener("scroll", this.getScroll);
    // listNotice().then((res) => {
    //   console.log(res);
    // });
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
    this.closeTime();
  },
  methods: {
    // 获取位置显示pc新闻资讯
    getScroll() {
      var a = document.getElementById("manor").scrollHeight;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (a + 400 < scrollTop) {
        this.show = true;
      }
    },
    // 跳转页面
    go(name) {
      this.getwg(name);
      this.$router.push({ name });
    },
    // 前往快速预约
    goyuyue() {
      var name = "yuyue";
      this.$router.push({ name });
    },
    // 快速拨号
    goGuide(id) {
      if (id === 4) {
        var a = `tel:0769-38803323`;
        window.location.href = a;
        return;
      }
      var name = "guide";
      this.$router.push({ name, query: { id } });
    },
    //取消loading1
    changeLoading1(index) {
      this.loading1 = false;
    },
    //取消loading3
    changeLoading2(index) {
      this.loading3 = false;
    },
    // 获取新闻列表
    getNews(index, name) {
      this.newType = index;
      if (name) {
        return;
      }
      this.loading1 = true;
      this.loading3 = true;
      newslist(this.form).then((res) => {
        this.newList1 = res.data.list;
        this.loadImage(res.data.list[0].images, this.changeLoading1);
      });
      videolist(this.form).then((res) => {
        res.data.list.forEach((item) => {
          item.images = item.cover_images;
        });
        this.newList2 = res.data.list;
        this.loadImage(res.data.list[0].images, this.changeLoading2);
      });
    },
    // 前往新闻详情页
    goNewsDetail(id) {
      if (this.newType === 1) {
        var name = "newsDetail";
        this.$router.push({ name, query: { id } });
      } else if (this.newType === 2) {
        var name = "videoDetail";
        this.$router.push({ name, query: { id } });
      }
    },
    //获取病历简介
    getPdf() {
      this.loading2 = true;
      synopsistop6().then((res) => {
        this.tsDetail = res.data;
        this.loading2 = false;
      });
    },
    // 跳转联系我们
    gocontact(id, index) {
      var name = "contact";
      this.$router.push({ name, query: { id } });
    },
    //跳转病历简介
    gomedical(item) {
      var name = "medicalRecordDetail";
      this.$router.push({
        name,
        query: { type: this.type, id: item.id },
      });
    },
    //跳转特色医疗
    gocharacteristic(id, index,isContent) {
      if(isContent === 0){
        return
      }
      var name = "characteristic";
      this.$router.push({
        name,
        query: { type: id, active: index },
      });
    },

    //特色医疗轮播动态
    // 初始化设定
    setSwipe() {
      this.nowSwipe = [];
      this.tsList1.forEach((item, index) => {
        if (index > 0) {
          // 使用下标对动态内容做标记，第一个内容固定不动
          this.nowSwipe.push(index);
        } else {
          //设置第一个内容位置样式
          document.getElementsByClassName("swipeClass")[
            index
          ].style = `transform:translateX(36vw);margin:0.20rem 0.05rem 0.2rem;position:absolute;z-index:5`;
        }
      });
      this.changeSwipe();
      // 启动定时器
      this.startTime1();
    },
    // 手指按下时记录起始位置
    swipeStart(e) {
      this.start = e.changedTouches[0].clientX;
      //清除当前定时器
      this.closeTime();
    },
    // 手指放开时执行
    swipeEnd(e) {
      var a = this.nowSwipe[0];
      var b = this.nowSwipe[this.nowSwipe.length - 1];
      // 判断手指移动方向
      if (e.changedTouches[0].clientX < this.start) {
        this.nowSwipe.splice(0, 1);
        this.nowSwipe.push(a);
      }
      if (e.changedTouches[0].clientX > this.start) {
        this.nowSwipe.splice(this.nowSwipe.length - 1, 1);
        this.nowSwipe.splice(0, 0, b);
      }
      this.changeSwipe();
      this.startTime1();
    },
    // 定时器
    startTime1() {
      var that = this;
      this.timer = setInterval(() => {
        var a = that.nowSwipe[0];
        that.nowSwipe.splice(0, 1);
        that.nowSwipe.push(a);
        this.changeSwipe();
      }, 3000);
    },
    // 清除定时器
    closeTime() {
      // console.log("清除定时器");
      clearInterval(this.timer);
    },
    // 变化位置
    changeSwipe() {
      var num = 36;
      this.nowSwipe.forEach((item, index) => {
        if (index === 0) {
          document.getElementsByClassName("swipeClass")[
            item
            //  translate3d(0px, 0px, -100px) rotateX(0deg) rotateY(-50deg)
          ].style = `transform:scale(0.8) translateX(-4vw);margin:0.20rem 0.05rem 0.2rem;position:absolute;z-index:3`;
        } else if (index === 1) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.9) translateX(18vw);margin:0.20rem 0.05rem 0.2rem;position:absolute;z-index:4`;
        } else if (index === 2) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.9) translateX(${
            num * 2 - 8
          }vw);margin:0.20rem 0.05rem 0.2rem;position:absolute;z-index:4`;
        } else if (index === 3) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.8) translateX(${
            num * 2.7
          }vw);margin:0.20rem 0.05rem 0.2rem;position:absolute;z-index:3`;
        } else if (index === 4) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.75) translateX(${
            26 * (this.tsList.length - index) - 62
          }vw) translateY(0.3rem);position:absolute;opacity: 0.5;z-index:1;pointer-events:none`;
        } else if (index === 5) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.7) translateX(${
            26 * (this.tsList.length - index) - 58
          }vw) translateY(0.3rem);position:absolute;opacity: 0.5;z-index:1;pointer-events:none`;
        } else if (index === 6) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.7) translateX(${
            26 * (this.tsList.length - index) - 50
          }vw) translateY(0.3rem);position:absolute;opacity: 0.5;z-index:1;pointer-events:none`;
        } else if (index === 7) {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.70) translateX(${
            26 * (this.tsList.length - index) - 41
          }vw) translateY(0.3rem);position:absolute;opacity: 0.5;z-index:1;pointer-events:none`;
        } else {
          document.getElementsByClassName("swipeClass")[
            item
          ].style = `transform:scale(0.75) translateX(${
            26 * (this.tsList.length - index) - 44
          }vw) translateY(0.3rem);position:absolute;opacity: 0.5;z-index:1;pointer-events:none`;
        }
      });
    },
    swipeMove(e){},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.manor {
  background-size: 100% 100%;
  height: 600px;
  color: #fff;
}
.manor > div {
  padding: 20px;
  height: 540px;
}
.home .tsNAame {
  transition: all 0.5s;
}
.home .tsNAame:hover {
  transform: scale(1.1);
}
.home .getMore {
  margin-top: 24px;
  color: #439392;
  border: 1px solid #439392;
  background-color: #fff;
  font-size: 16px;
  border-radius: 0;
  padding: 0;
  width: 146px;
  height: 40px;
  line-height: 40px;
  transition: all 0.5s;
}
.manor .getMore {
  margin-top: 24px;
  color: #439392;
  border: 1px solid #439392;
  /* background-color: rgba(255,255,255,0.7); */
  background-color: #fff;
  font-size: 14px;
  border-radius: 0;
  padding: 0;
  width: 136px;
  height: 35px;
  line-height: 35px;
  transition: all 0.5s;
}
.home .getMore:hover {
  color: #439392;
  text-decoration: underline;
}

.manor .getMore:hover {
  color: #439392;
  text-decoration: underline;
}
.homePage .mobile .mob-select {
  text-align: center;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.14rem;
  background-color: #763a27;
  color: #fff;
  flex: 1;
}
.homePage .mobile .mob-noSelect {
  text-align: center;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.14rem;
  background-color: #ab7a2b;
  color: #fff;
  flex: 1;
}
.gongImg {
  width: 0.5rem;
  height: 0.5rem;
}
.gongText {
  font-size: 0.14rem;
  margin-top: 0.1rem;
}

.triangle-down {
  width: 0;
  height: 0;
  border-left: 0.1rem solid transparent;
  border-right: 0.1rem solid transparent;
  border-top: 0.1rem solid #763a27;
  margin: -2px auto 0;
  z-index: -1;
}
.homePage .newstitle {
  -webkit-line-clamp: 1;
  margin-bottom: 0.05rem;
  font-weight: bold;
}
.homePage .records {
  overflow: hidden; /*最外层设置  溢出隐藏  */
}
.homePage .records ul {
  white-space: nowrap; /*第二层设置  不换行  */
  overflow-y: hidden; /*溢出框 提供滚动机制*/
}
.homePage .records li {
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  width: 30%;
  margin-right: 0.1rem;
  height: 0.3rem;
  line-height: 0.3rem;
  padding: 1px 15px;
  width: auto;
  text-align: center;
  font-size: 14px;
  display: inline-block; /*最内层div设置inline-block*/
}
.homePage .records .ts-select {
  background-color: #439392;
  color: #fff;
}
.homePage .records li:last-child {
  margin-right: 0;
}
.homePage .active1-img {
  display: table-cell;
}
.homePage .active1-img div {
  width: calc(100% / 2 - 0.05rem);
  float: left;
  margin-top: 0.1rem;
}
.homePage .active1-img div:nth-child(2n) {
  width: calc(100% / 2 - 0.05rem);
  margin-left: 0.1rem;
  float: right;
}
.homePage .active1-img img {
  width: 100%;
  height: 1rem;
  vertical-align: middle;
}
.homePage .mobile .swipeClass {
  transition: transform 0.5s ease-in-out;
  transition: all 0.5s;
  z-index: 0;
}
.homePage .mobile .jzBg {
  background-image: url("../assets/mobile/timg.png");
  margin-right: 0.05rem;
  width: 0.5rem;
  background-size: 100% 100%;
  padding: 0.6rem 0.1rem;
  z-index: 1;
  height: 240px;
  color: #754505;
}

.homePage .mobile .swipeClass:first-child .jzBg {
  background-image: url(../assets/mobile/timg1.png);
  color: #5e2500;
  width: 0.55rem;
}
.homePage .mobile .swipeClass:first-child .jzBg div {
  display: table-cell;
  padding: 0.1rem 0.13rem;
  vertical-align: middle;
}
.homePage .mobile .jzBg:last-child {
  margin-right: 0rem;
}
.homePage .mobile .jzBg div {
  display: flex;
  align-items: center;
  width: 0.28rem;
  font-size: 0.17rem;
  margin: 0 auto;
  padding: 0.1rem 0rem;
  height: 2.2rem;
  line-height: 0.23rem;
  text-align: center;
  font-weight: bold;
  z-index: 1;
}
.list-tit {
  width: 100%;
  background: url(../assets/mobile/b2.png) no-repeat 0 bottom;
  background-size: 100%;
  border-bottom: 0;
}
.list-tit div span {
  border-bottom: 0;
}
.homePage .mobile .list-eng {
  color: #999;
  font-size: 0.12rem;
}
.homePage .mobile .moreBtn {
  background: #ff7a03;
  margin: 0.25rem auto 0.35rem;
  font-size: 0.14rem;
  text-align: center;
  border-radius: 50px;
  height: 0.32rem;
  line-height: 0.32rem;
  width: 80%;
  color: #fff;
}
.swipe-bg {
  background-image: url(../assets/mobile/bg.png);
  background-size: 100% 100%;
  padding: 0 10px;
  z-index: 0;
  height: 400px;
}
.homePage .newList .van-tabs__wrap {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue